/**
 * @see https://github.com/Les-Pretentieux/Blueprint/blob/1ea3427d7e0fa8f5920a7dabaf649627f1703102/docs/components.md
 */

import { module as modujs } from "modujs";

import { gsap } from "gsap";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				head: "click",
			},
		};
	}

	init() {
		this.$body = this.$("body")[0];
		this.$content = this.$("content")[0];

		this._resizeHandler = this.resize.bind(this);
		window.addEventListener("resize", this._resizeHandler);

		document.fonts.ready.then(() => {
			this.calc();
		});
	}

	resize() {
		if (this.resizeTimeout != undefined) {
			this.resizeTimeout.kill();
		}

		this.el.classList.add("is-resizing");

		this.calc();

		this.resizeTimeout = gsap.delayedCall(0.1, () => {
			this.el.classList.remove("is-resizing");
		});
	}

	calc() {
		this.el.style.setProperty("--height", this.$content.getBoundingClientRect().height + "px");
	}

	click() {
		this.el.classList.toggle("is-expanded");
		this.$body.setAttribute("aria-expanded", this.$body.getAttribute("aria-expanded") == "true" ? "false" : "true");
	}

	destroy() {
		window.removeEventListener("resize", this._resizeHandler);
	}
}
